import {useEffect, useState} from "react";

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(() => typeof window !== "undefined" && window.innerWidth < 640);
    useEffect(() => {
        const mq = window.matchMedia("(max-width: 639px)");
        const handler = e => setIsMobile(e.matches);
        mq.addEventListener("change", handler);
        return () => mq.removeEventListener("change", handler);
    }, []);
    return isMobile;
};
